export enum PickupType {
    Now = 1,
    Later,
    Unknow,
}